import React from "react";
import { REGEXP_ONLY_DIGITS } from "input-otp";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "../ui/input-otp";

// Six separate digit boxes for OTP entry. Accepts pasted codes and OS one-time-code
// autofill (autoComplete), and calls onChange with the digits string.
export function OtpBoxes({ value, onChange, autoFocus = false, disabled = false, testId = "otp-boxes" }) {
  return (
    <InputOTP
      maxLength={6}
      value={value}
      onChange={onChange}
      autoFocus={autoFocus}
      disabled={disabled}
      inputMode="numeric"
      autoComplete="one-time-code"
      pattern={REGEXP_ONLY_DIGITS}
      containerClassName="justify-center"
      data-testid={testId}
    >
      <InputOTPGroup className="gap-2 sm:gap-2.5">
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <InputOTPSlot key={i} index={i} className="h-12 w-11 rounded-xl border text-xl font-semibold" />
        ))}
      </InputOTPGroup>
    </InputOTP>
  );
}
